import React from "react";
import { Polygon } from "react-native-svg";
import { Icon } from "~/native-ui";

export default (props) => {
    return (
        <Icon { ...props } viewBox="0 0 16 16">
            <Polygon points="0,5 8,9 15,5.5 15,14 16,14 16,5 8,1 " />
            <Polygon points="3,7.059 3,11.5 8,14 13,11.5 13,7.059 8,9.559 " />
        </Icon>
    )
}